module.exports =  {
    totalGemSubscribeDays:15,
    totalGemSubscribeDayRewards:450,
    specialLuckyChestPerDay:3,
    specialLuckyChestCost:5,
    epicWeaponCost:60,
    luckyChestCost:12,
    chestRndGoldAppear:90,
    chestRndGemAppear:10,
    chestGemGoldRewardMinExchange:5,
    chestGemGoldRewardMaxExchange:8,
    chestGemPlusMinReward:1,
    chestGemPlusMaxReward:3,
};